import { createContext } from 'react'

export type RoomContextType = {
  id?: number
  roomName?: string
  roomSid?: string
  serverUrl?: string
  token?: string
}

export interface RoomContextState {
  room: RoomContextType | null
  isSideBarOpen: boolean
  setIsSideBarOpen: (state: boolean) => void
  isChatOpen: boolean
  setIsChatOpen: (state: boolean) => void
  loading: boolean
  error: boolean
  errorMessage: string | null
  refetchRoom: () => Promise<void>
  resetError: () => void
  // Meeting sounds settings
  soundsEnabled: boolean
  setSoundsEnabled: (enabled: boolean) => void
  // Pending messages
  pendingMessagesCount: number
  addPendingMessage: () => void
  clearPendingMessages: () => void
  // Meeting id handling
  meetingId: number | null
  setMeetingId: (id: number | null) => void
}

export const RoomContext = createContext<RoomContextState | undefined>(undefined)
